import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation(['auth']);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.login(username, password);

      // Сохраняем токен
      localStorage.setItem('token', response.data.token);

      // Сохраняем user (нужно для ProtectedRoute и определения роли)
      localStorage.setItem('user', JSON.stringify(response.data.user));

      // Redirect: руководство → AdminDashboard, остальные → DepartmentDashboard
      const u = response.data.user;
      const leadershipRoles = ['admin', 'director', 'deputy_director'];
      if (u.is_superuser || u.is_staff || leadershipRoles.includes(u.role)) {
        navigate('/dashboard/admin');
      } else {
        navigate('/dashboard/department');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(t('auth:invalidCredentials'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img
            src="/logo_white.png"
            alt="Farmatsevtika mahsulotlari xavfsizligi markazi"
            className="login-logo"
          />
          <h1>{t('auth:title')}</h1>
          <p>{t('auth:subtitle')}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>{t('auth:loginLabel')}</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('auth:loginPlaceholder')}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>{t('auth:passwordLabel')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('auth:passwordPlaceholder')}
              required
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? t('auth:loggingIn') : t('auth:loginButton')}
          </button>
        </form>

        <div className="login-footer">
          <p>{t('auth:orgName')}</p>
          <p>{t('auth:ministryName')}</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
